/**
 * @author Ariel
 * @Date 2023/2/2
 */
import React from "react";
import { connect } from "dva";
import { templateConfig, reduxTemplateConfig } from "./config";

import { framework_tool, component_tool } from '../../../tool';
import { exportPdf } from '@/utils';
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf'

let { WizContainer, WizReduxTemplate } = framework_tool;
let { WizSpin } = component_tool;

class InviteLetterManager extends WizContainer {
  componentName = 'inviteLetterManager';

  constructor(props) {
    super(props);
    this.state = {
      downloadLoading: false
    }
  };

  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key];
    if (o['success']) {
      wizNotice.success(o['msg']);
      return true;
    } else {
      wizNotice.error(o['msg']);
      return false;
    }
  }

  _btnFun = ({ record }) => {

    // 优化体验,加入一个loading
    this.setState({
      downloadLoading: true
    })

    // 设置放大倍数
    let scale = 1.5

    // 先追加一个dom,下载后删除
    let addDom = document.createElement('div')
    let domBody = document.body
    addDom.innerHTML = record.content
    addDom.setAttribute('id', 'letter-pdf')
    addDom.style = `padding: 20px 30px;width:${535*scale}px;`
    // 如果有图片,加入跨域
    // let arrImg = addDom.querySelectorAll('img')
    // if (arrImg.length) {
    //   for (let i = 0; i < arrImg.length; i++) {
    //     arrImg[i].setAttribute('crossorigin', 'anonymous')
    //   }
    // }
    domBody.appendChild(addDom)

    let opts = {
      useCORS: true, // 允许加载跨域的图片
      allowTaint: false,
      tainttest: true, // 检测每张图片都已经加载完成
      logging: true,
      backgroundColor: '#FFF',
      width: 595.28*scale,
    }

    // 下载图片
    html2canvas(document.getElementById('letter-pdf'), opts).then(canvas => {
      // const imgUrl = canvas.toDataURL('image/png').replace('image/png', 'image/octet-stream')
      // let link = document.createElement('a');
      // link.href = imgUrl;
      // link.download = `${record.title}_${new Date().getTime()}.png`;
      // link.click();

      let w = 595.28 // a4宽
      let h = canvas.height/scale < 841 ? 841 : canvas.height/scale // 补全最小高度

      let pageData = canvas.toDataURL('image/png', 1.0)
      let PDF = new jsPDF('p', 'pt', [w, h])
      PDF.addImage(pageData, 'png', 0, 0, w, 0)
      PDF.save(`${record.title}_${new Date().getTime()}.pdf`);

      domBody.removeChild(addDom)
      this.setState({
        downloadLoading: false
      })
    }).catch(err => {
      domBody.removeChild(addDom)
      this.setState({
        downloadLoading: false
      })
    });
  }


  _render() {

    let { downloadLoading } = this.state

    let _reduxTemplateConfig = reduxTemplateConfig({
      templateConfig: templateConfig({ _btnFun: (e) => { this._btnFun(e) } }),
      apiDataFormat: {
        add: this._handleCMD,
        update: this._handleCMD,
        enable: this._handleCMD,
      },
    })

    return (
      <WizSpin spinning={downloadLoading}>
        <WizReduxTemplate {..._reduxTemplateConfig} />
      </WizSpin>
    )
  }
};

const mapStateToProps = (state, ownProps) => {
  return {}
};

export default connect(mapStateToProps)(InviteLetterManager);
